import React, { FC } from 'react';
import { BKJButton } from '@bookjane2/bookjane-design-library';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { Flex } from 'components/Flex';

import {
  CSVBorderHeaderStyle,
  H3,
  TeamMemberCSVWrapper,
  LocationHeader,
} from 'components/InviteTeamMembersByCSVModal/views/EditRanking/TeamMemberEditRankingView.styled';
import { UnSuccessTeamMemberTable } from 'components/InviteTeamMembersByCSVModal/views/ImportViaSpreadsheet/views/UnSuccessView/TeamMemberTable/UnSuccessTeamMemberTable';
import { inviteTeaMemberCSVModalRoutingService } from 'components/InviteTeamMembersByCSVModal/InviteTeamMembersByCSVModal.ui.context';
import { TeamMemberCSVViewFormProvider } from 'components/InviteTeamMembersByCSVModal/views/ImportViaSpreadsheet/TeamMemberCSVView.form.context';
import { useTranslation } from 'hooks/useTranslation';
export const Component: FC = () => {
  const { t } = useTranslation();
  return (
    <Flex
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      width="100%"
      flexGrow={1}
      borderTop={CSVBorderHeaderStyle}
    >
      <Flex flexDirection="column" padding="32px 40px 15px" gap="32px">
        <H3>{t('team_member:IMPORT_UNSUCCESSFUL')}</H3>
        <TeamMemberCSVWrapper>
          <LocationHeader>{t('team_member:CORRECT_ERRORS_AND_UPLOAD_AGAIN')}</LocationHeader>
        </TeamMemberCSVWrapper>
      </Flex>
      <UnSuccessTeamMemberTable />

      <Flex height="100%"></Flex>
      <BKJSideModalFooter justifyContent="space-between" flexDirection="row-reverse">
        <BKJButton
          variant="PurpleSolid"
          width="180px"
          onClick={() => inviteTeaMemberCSVModalRoutingService.goToPrevView()}
          type="button"
        >
          {t('team_member:GO_BACK')}
        </BKJButton>
      </BKJSideModalFooter>
    </Flex>
  );
};
export const EditRankingUnSuccessView: FC = () => {
  return (
    <TeamMemberCSVViewFormProvider>
      <Component />
    </TeamMemberCSVViewFormProvider>
  );
};
